<mat-checkbox
  class="mat-option"
  [indeterminate]="isIndeterminate()"
  [checked]="isChecked()"
  (mousedown)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
  (change)="toggleSelection($event)"
>
  {{ text }}
</mat-checkbox>
